import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { SignupContext } from "../../../context/SignupContext";
import * as Yup from "yup";
import Button from "../../../components/Button";
import Loader from "../../../components/Loader";
import { auth } from "../../../firebase/firebase";
import { sendPasswordResetEmail, sendSignInLinkToEmail } from "firebase/auth";
import APILoader from "../../../components/APILoader";
import { BASE_API_URL, BASE_URL } from "../../../config";

const Step1 = () => {
  const navigate = useNavigate();
  const [updatingUser, setUpdatingUser] = useState(false);

  const schema = Yup.object().shape({
    email: Yup.string().email().required(`Email is required!`),
  });

  const { formData, updateFormData } = useContext(SignupContext);
  const { email } = formData;
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  const checkUserOrValidateDOB = async (email: string) => {
    try {
      const response = await fetch(`${BASE_API_URL}/validateEmail`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        setErrors(prev => ({ ...prev, email: data.error }));
        return false;
      }

      console.log("Response:", data);
      return true;
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setUpdatingUser(true);

    setErrors({});
    const isValid = await checkUserOrValidateDOB(email);

    if (!isValid) {
      setUpdatingUser(false);
      setErrors({ email: "Email is not registered with Skarvo" });
      return;
    }

    const actionCodeSettings = {
      url: `${BASE_URL}/resetPassword/passwordReset?email=${email}`,
      handleCodeInApp: true,
    };
    try {
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      console.log("Password reset email sent successfully");
    } catch (error) {
      console.error("Error sending password reset email:", error);
      throw error;
    }
    navigate("./emailConfirmation");
  };

  const isValid = () => {
    return Object.keys(errors).length === 0;
  };

  useEffect(() => {
    setErrors({ email: "" });
    return () => {};
  }, []);

  const onBlurMe = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    const isValid = await validateForm(name, value);
  };
  const validateForm = async (name: string, value: string) => {
    try {
      await schema.validateAt(name, { [name]: value });

      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  const updateValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const newValue = { ...formData, [name]: value };
    updateFormData(newValue);
  };

  return (
    <>
      {/* {updatingUser && <Loader />} */}
      <APILoader loading={updatingUser} />
      <section>
        <div className="container">
          <div className="grid grid-cols-1 gap-3 p-5 md:grid-cols-2 gap-x-5 gap-y-5">
            {/* Left Container */}
            <div className="flex flex-col items-start justify-start">
              <h1 className="herotitle">Skarvo</h1>
              <p className="text-xl font-normal">Your email associated with your Skarvo Business account.</p>
            </div>

            {/* Right Container */}
            <div className="flex flex-col gap-10">
              <div className="flex flex-col items-start formcard">
                <div className="flex flex-row items-start formheader">
                  <div className="text-xl font-bold text-center mt-[15px] mb-[30px]">Password Reset</div>
                </div>
                <div className="mb-5 px-[30px] flex flex-col space-x-[10x] w-full">
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Email"
                    required
                    onChange={updateValue}
                    onBlur={onBlurMe}
                  />
                  {errors.email && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.email}</span>}
                </div>

                <div className="flex justify-center w-full px-[30px] mb-[30px]"></div>
                <div className="thickseparator"></div>
                <div className="flex flex-col items-center justify-between w-full p-[30px] md:flex-row-reverse  gap-y-[30px]">
                  <Button to="/verify" onClick={handleSubmit} className="w-full md:w-auto md:min-w-[120px] formprimarybutton" isDisabled={!isValid()}>
                    Continue
                  </Button>
                  <Link to="/" className="w-full md:w-auto md:min-w-[180px] formsecondarybutton">
                    Cancel
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Step1;
